import styled from 'styled-components'

import ImageFromBucket from '~/shared/components/common/ImageFromBucket'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

function CircleInfoTopSection() {
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium

  const titleText = isMobile
    ? `「서클 부스」 는 서브컬쳐 문화를 즐기고 좋아하는 창작자 및 창작 팀들을 위한, 크리에이터 플리마켓 공간입니다.`
    : `「서클 부스」 는 서브컬쳐 문화를 즐기고 좋아하는 창작자 및 창작 팀들을 위한,\n크리에이터 플리마켓 공간입니다.`

  return (
    <Wrapper>
      <Title>서클 부스</Title>
      <BackgroundImage
        src="assets/background/circle-only-bg-2560.webp"
        alt="Background Image"
      />
      <Desc>{titleText}</Desc>
      <List>
        <li>
          ▪ 서클 참가자는 지정 부스 공간 내에서 창작물을 전시/배포/판매하실 수
          있습니다.
        </li>
        <li>▪ 자세한 내용은 「서클 참가 안내」 를 살펴봐주세요.</li>
        <li>▪ 서클참가 신청 전 「서클 규정」 을 꼭 확인해 주세요.</li>
      </List>
    </Wrapper>
  )
}

export default CircleInfoTopSection

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;

  box-sizing: border-box;
  margin-top: 124px;

  @media ${theme.device.large} {
    gap: 20px;
    height: auto;
  }

  @media ${theme.device.medium} {
    gap: 12px;
    margin-top: 56px;
  }
`

const BackgroundImage = styled(ImageFromBucket)`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  width: 100%;
  height: 550px;

  object-fit: cover;
  background-color: ${theme.colors.mint_2};

  @media ${theme.device.medium} {
    height: 450px;
    object-fit: cover;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 59px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 28px;
    line-height: 40px;
  }
`

const Desc = styled.p`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 16px;
    line-height: 28px;
  }
`

const List = styled.ul`
  padding-inline-start: 24px;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;

  @media ${theme.device.medium} {
    width: 100%;
    padding-inline-start: 0;
    font-size: 14px;
  }
`
